import React, { useEffect } from 'react';

export default function usePageShow<T>(callback: (deps?: T[]) => void, force?: boolean) {
  force = force ?? true;
  useEffect(() => {
    const pageShow = event => {
      const historyTraversal =
        event.persisted || (typeof window.performance != 'undefined' && window.performance.navigation.type === 2);
      if (force) {
        callback();
      } else {
        if (historyTraversal) {
          callback();
        }
      }
    };
    window.addEventListener('pageshow', pageShow);
    return () => {
      window.removeEventListener('pageshow', pageShow);
    };
  }, []);
}
